export default __webpack_public_path__ + "static/media/24-FarmhouseInSanCasciano.203377ea.jpeg";